import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { Typography } from "../Typography/index.js";
import { Box } from "../Box/index.js";
import { StageEnd } from "./StageEnd.js";
import { StageStart } from "./StageStart.js";
import { useStyles } from "./Stage.styles.js";
const Stage = (t0)=>{
    const $ = c(33);
    const { className, first: t1, label, last: t2, fullWidth: t3, size: t4, status: t5 } = t0;
    const first = void 0 === t1 ? false : t1;
    const last = void 0 === t2 ? false : t2;
    const fullWidth = void 0 === t3 ? false : t3;
    const size = void 0 === t4 ? "medium" : t4;
    const status = void 0 === t5 ? "initial" : t5;
    const { classes } = useStyles();
    const completed = "completed" === status;
    const active = "active" === status;
    const widthForContainer = fullWidth ? "100%" : "auto";
    const t6 = !first && classes.offsetToLeft;
    const t7 = !first && "small" === size && classes.offsetToLeftSmall;
    const t8 = `aqa_stage_${status}`;
    let t9;
    if ($[0] !== className || $[1] !== t6 || $[2] !== t7 || $[3] !== t8) {
        t9 = classnames(className, t6, t7, "aqa_stage", t8);
        $[0] = className;
        $[1] = t6;
        $[2] = t7;
        $[3] = t8;
        $[4] = t9;
    } else t9 = $[4];
    let t10;
    if ($[5] !== first || $[6] !== status) {
        t10 = /*#__PURE__*/ jsx(StageStart, {
            first: first,
            status: status
        });
        $[5] = first;
        $[6] = status;
        $[7] = t10;
    } else t10 = $[7];
    const t11 = active ? 0.6 : 1;
    const t12 = fullWidth && classes.fullWidthStageContent;
    const t13 = completed && classes.completed;
    const t14 = active && classes.active;
    const t15 = "medium" === size && classes.contentMedium;
    let t16;
    if ($[8] !== classes.content || $[9] !== t12 || $[10] !== t13 || $[11] !== t14 || $[12] !== t15) {
        t16 = classnames(classes.content, t12, t13, t14, t15);
        $[8] = classes.content;
        $[9] = t12;
        $[10] = t13;
        $[11] = t14;
        $[12] = t15;
        $[13] = t16;
    } else t16 = $[13];
    const t17 = completed || active ? "text.dark.primary" : "text.light.primary";
    let t18;
    if ($[14] !== label || $[15] !== t17) {
        t18 = /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: t17,
            children: label
        });
        $[14] = label;
        $[15] = t17;
        $[16] = t18;
    } else t18 = $[16];
    let t19;
    if ($[17] !== t11 || $[18] !== t16 || $[19] !== t18) {
        t19 = /*#__PURE__*/ jsx(Box, {
            opacity: t11,
            className: t16,
            children: t18
        });
        $[17] = t11;
        $[18] = t16;
        $[19] = t18;
        $[20] = t19;
    } else t19 = $[20];
    let t20;
    if ($[21] !== last || $[22] !== status) {
        t20 = /*#__PURE__*/ jsx(StageEnd, {
            last: last,
            status: status
        });
        $[21] = last;
        $[22] = status;
        $[23] = t20;
    } else t20 = $[23];
    let t21;
    if ($[24] !== t10 || $[25] !== t19 || $[26] !== t20 || $[27] !== widthForContainer) {
        t21 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            width: widthForContainer,
            children: [
                t10,
                t19,
                t20
            ]
        });
        $[24] = t10;
        $[25] = t19;
        $[26] = t20;
        $[27] = widthForContainer;
        $[28] = t21;
    } else t21 = $[28];
    let t22;
    if ($[29] !== t21 || $[30] !== t9 || $[31] !== widthForContainer) {
        t22 = /*#__PURE__*/ jsx(Box, {
            display: "flex",
            flexWrap: "nowrap",
            width: widthForContainer,
            className: t9,
            testId: "stage-test-id",
            children: t21
        });
        $[29] = t21;
        $[30] = t9;
        $[31] = widthForContainer;
        $[32] = t22;
    } else t22 = $[32];
    return t22;
};
export { Stage };
